
import React from "react";
import autobind from "react-autobind";
import { actions } from "@gsd/redux-store-backoffice";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Acls from "../component/Acls/Acls";

const {
  idmBackOffice: {
    creators: {
      getAcls,
      upsertAcl,
      getApplications,
    }
  }
} = actions;

const mapStateToProps = state => ({
  ...state.idmBackOffice
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getAcls: () => dispatch(getAcls()),
    upsertAcl: (obj: any) => dispatch(upsertAcl(obj)),
    getApplications: () => dispatch(getApplications()),
  };
};
type AclContainerProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
class AclContainer extends React.Component<AclContainerProps> {
  constructor(props:AclContainerProps) {
    super(props);
    autobind(this);
  }

  async componentDidMount() {
    await this.props.getAcls();
    await this.props.getApplications();
  }
  _upsertElement = async (obj: unknown) => {
    await this.props.upsertAcl(obj);
    await this.props.getAcls();
  };
  render() {
    const { acls, applications } = this.props;
    return (
      <Acls
        dataElements={acls}
        upsertElement={this._upsertElement}
        applications={applications}
      />
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AclContainer);
